import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from 'vue';
import { useFeed } from '../utils';
import ExtraFieldInput from './components/ExtraFieldInput.vue';
import { useActions } from 'vuex-composition-helpers';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExtraFieldsSettings',
    setup(__props) {
        const { feed } = useFeed();
        const { patch: updateFeed } = useActions('feed', ['patch']);
        const additionalFields = computed(() => {
            return Object.entries(feed.value?.additionalFields ?? {}).map(([key, value]) => ({ key, value }));
        });
        const newField = ref({ key: '', value: '' });
        function addField() {
            if (!feed.value?._id)
                return;
            if (!newField.value.key)
                return;
            updateFeed([feed.value?._id, { $set: { ['additionalFields.' + newField.value.key]: newField.value.value } }, {}]);
            newField.value = { key: '', value: '' };
        }
        function deleteField(fieldKey) {
            if (!feed.value?._id)
                return;
            updateFeed([feed.value?._id, { $unset: { ['additionalFields.' + fieldKey]: 1 } }, {}]);
        }
        return { __sfc: true, feed, updateFeed, additionalFields, newField, addField, deleteField, ExtraFieldInput };
    }
});
